export default (state = [], action) => {
    switch (action.type) {
        case 'SET_SCHEDULE': {
            return Object.assign({}, state, {
                schedule: action.data.schedule,
                loading: action.data.loading,
                organization: action.data.organization,
                organizationShortName: action.data.organizationShortName
            })
        }

        case 'SET_SCHEDULE_PERSONAL': {
            return Object.assign({}, state, {
                schedulePersonal: action.schedule
            })
        }

        case 'SET_SCHEDULE_DEEP': {
            return Object.assign({}, state, {
                days: action.days
            })
        }

        case 'SET_ORGANIZATION_LIST': {
            return Object.assign({}, state, {
                organizationsList: action.list
            })
        }

        case 'SET_ORGANIZATION': {
            return Object.assign({}, state, {
                organizationCode: action.data.organizationCode,
                organization: action.data.organization,
                organizationShortName: action.data.organizationShortName
            })
        }

        case 'SET_SESSION_TYPES_LIST': {
            return Object.assign({}, state, {
                tSesList: action.list
            })
        }

        case 'SET_SESSION_TYPE': {
            return Object.assign({}, state, {
                tSes: action.tSes
            })
        }

        case 'SET_HOVER_ROW_TITLE': {
            return Object.assign({}, state, {
                rowTitlePosition: action.rowTitlePosition
            })
        }

        default:
            return state;
    }
}